<template>
  <div>
    <v-card>
      <v-form ref="form" class="multi-col-validation">
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">{{title_details}}</h4>
          </v-toolbar-title>
        </v-toolbar>

        <v-layout row wrap class="align-center mx-2 mt-5">
          <v-flex xs12 md12>
            <v-checkbox v-model="is_company" label="Is Company?" hide-details
                        class="me-3 mt-1"></v-checkbox>
            <v-checkbox v-model="same_details" label="Same Details ?" hide-details
                        class="me-3 mt-1"></v-checkbox>
          </v-flex>
          <v-flex xs12 md12>

            <v-flex xs12 md12 v-if="is_company" class="mt-4">
              <v-text-field
                class="mx-2"
                v-model="company_name"
                dense
                label="Company Name"
                outlined
                :rules="rules.default_max_255_character_and_no_empty_rule"
              ></v-text-field>
            </v-flex>
          </v-flex>

          <v-flex xs12 md4 v-if="!is_company" class="mt-4">
            <v-text-field
              class="mx-2"
              v-model="last_name"
              dense
              label="Last Name"
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md4 v-if="!is_company" class="mt-4">
            <v-text-field
              class="mx-2"
              v-model="middle_name"
              dense
              label="Middle Name"
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md4 v-if="!is_company" class="mt-4">
            <v-text-field
              class="mx-2"
              v-model="first_name"
              dense
              label="First Name"
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-row>
          <!-- alert -->
          <v-col cols="12" v-show="alert">
            <v-alert
              color="warning"
              text
              class="mb-0"
            >
              <div class="d-flex align-start">
                <v-icon color="warning">
                  {{ icons.mdiAlertOutline }}
                </v-icon>

                <div class="ms-3">
                  <p class="text-base font-weight-medium mb-1">
                    {{alert_message}}
                  </p>
                </div>
              </div>
            </v-alert>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn
              class="w-full"
              color="primary"
              @click="done_request"
              v-if="!saving_request"
            >
              Done
            </v-btn>
            <v-progress-circular
              :size=50
              :width="5"
              color="primary"
              indeterminate
              v-else
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>
<script>

  import {mdiAlertOutline} from "@mdi/js";
  import {mapActions, mapGetters} from "vuex";

  const initialState = () => {
    return {
      saving_request: false,
      alert: false,
      alert_message: '',

      is_company: false,
      same_details: false,
      company_name: '',
      last_name: '',
      first_name: '',
      middle_name: '',

      title_details: '',
    }
  }
  export default {
    props: {
      information_details: String,
    },
    setup() {
      return {
        icons: {
          mdiAlertOutline,
        },
      }
    },
    data() {
      return initialState();
    },
    mounted() {
      this.title_details = this.information_details + ' Information'
    },
    computed: {
      ...mapGetters('form_rules', ['rules']),
    },
    methods: {
      ...mapActions('request_data', ['check_under_particulars_availability']),
      done_request() {
        this.saving_request = true
        this.alert = false
        if (this.$refs.form.validate()) {
          if (this.is_company) {
            this.$emit('data', this.company_name.toUpperCase(), this.same_details, this.information_details)
          } else {
            this.$emit('data', this.last_name.toUpperCase() + ', ' + this.first_name.toUpperCase() + ' ' + this.middle_name.toUpperCase(), this.same_details, this.information_details)
          }

          this.saving_request = false
        } else {
          this.alert = true
          this.alert_message = 'Please Fill up the field/s'
          this.saving_request = false
        }
      },
    }
  }
</script>
